import type { ExperienceActionDto } from "@intelligems/ig-types/dtos/experience-actions";

export const getDaysFromHistory = (
  experienceActions: ExperienceActionDto[],
  endTs?: number
) => {
  const actions = [...experienceActions];
  actions.sort((a, b) => a.actionTs - b.actionTs);

  let totalLiveTime = 0;
  let liveStart: number | null = null;

  for (const action of actions) {
    if (action.action === "start") {
      if (liveStart === null) {
        liveStart = action.actionTs;
      }
      continue;
    }

    if (
      (action.action === "pause" || action.action === "end") &&
      liveStart !== null
    ) {
      totalLiveTime += action.actionTs - liveStart;
      liveStart = null;
    }
  }

  if (liveStart !== null) {
    totalLiveTime += (endTs ?? Date.now()) - liveStart;
  }

  return totalLiveTime / (1000 * 60 * 60 * 24);
};
